import { QueryResult } from '@apollo/client'
import {
  GetRfiResponseDisciplinesQuery,
  useGetRfiResponseDisciplinesQuery,
} from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetRfiResponseDisciplinesQueryResult =
  QueryResult<GetRfiResponseDisciplinesQuery>
export type RFIResponseDiscipline =
  GetRfiResponseDisciplinesQuery['rfiResponseDisciplines']['records'][number]

const { Provider, useContextFn } = createStrictContext<{
  records: RFIResponseDiscipline[]
  refetch: GetRfiResponseDisciplinesQueryResult['refetch']
  fetching: GetRfiResponseDisciplinesQueryResult['loading']
}>('ResponseDisciplineTableContext')

export const useResponseDisciplinesTableContext = useContextFn

export const ResponseDisciplinesTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetRfiResponseDisciplinesQuery({
    ...DefaultQueryHookOptions,
    variables: {
      rfiResponseDisciplineListInput: {
        projectId: { equals: projectId },
      },
    },
  })
  return (
    <Provider
      value={{
        records: data?.rfiResponseDisciplines?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
